import { useCurrentLeagueContext } from "@/contexts";
import { CapabilitySet, EMPTY_CAPABILITY_SET } from "@/types/capability.types";

/**
 * Capability set the current user holds on the active league's LEAGUE node.
 * Empty when no league is selected, while it is unresolved, or when the BE has
 * not shipped the ref `capabilities` field yet — under strict RBAC an empty set
 * denies (fail closed).
 */
export const useLeagueCapabilities = (): CapabilitySet => {
  const { league } = useCurrentLeagueContext();
  return league?.capabilities ?? EMPTY_CAPABILITY_SET;
};
